<template>
    <span>     
         <img style="height:100%;width:100%;" src="../../assets/images/ic_doc.svg" alt /> 
    </span>
</template>
<script>
export default{
    name: 'DefaultViewer',
}
</script>